import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Shared hook for work anniversaries (DOJ) in the next 7 days.
 * Refreshes every 30 min while the tab is open.
 */
export function useAnniversariesThisWeek(user) {
  const [data, setData] = useState({ rows: [], count: 0, today: "" });
  const [loading, setLoading] = useState(false);
  const eligible = !!user && ["super_admin", "hr", "senior_management", "hod"].includes(user.role);

  useEffect(() => {
    if (!eligible) return;
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const { data: d } = await api.get("/anniversaries/this-week");
        if (!cancelled) setData(d);
      } catch { /* silent */ }
      finally { if (!cancelled) setLoading(false); }
    };
    load();
    const id = setInterval(load, 30 * 60 * 1000);
    return () => { cancelled = true; clearInterval(id); };
  }, [eligible]);

  return { ...data, loading, eligible };
}

/**
 * Build WhatsApp appreciation message link for a given employee.
 */
export function buildAnniversaryWaLink(emp) {
  const digits = String(emp?.mobile || "").replace(/\D/g, "");
  let e164 = digits;
  if (digits.length === 10) e164 = `91${digits}`;
  else if (digits.length === 11 && digits.startsWith("0")) e164 = `91${digits.slice(1)}`;
  if (!e164 || e164.length < 10) return null;
  const firstName = (emp?.name || "").split(" ")[0] || emp?.name || "";
  const years = emp?.years_completing || 1;
  const yearLabel = years === 1 ? "1 year" : `${years} years`;
  const msg = `Congratulations ${firstName}! 🏆\n\nCelebrating ${yearLabel} of dedicated service at Bravura Packers. Thank you for your continued contribution and commitment.\n\nWishing you many more successful years ahead.\n\n— Team Bravura`;
  return `https://wa.me/${e164}?text=${encodeURIComponent(msg)}`;
}

export function anniversaryDayLabel(daysUntil) {
  if (daysUntil === 0) return "Today";
  if (daysUntil === 1) return "Tomorrow";
  return `In ${daysUntil} days`;
}
